module.exports = __webpack_public_path__ + "static/media/about_armenia_0.3dc10046.jpg";